import Box from '@mui/material/Box';
import { FC } from 'react';

import { IAuthTypeForm } from '../../auth.interface';

import styles from './AuthBottom.module.sass';
import AuthBottomLogin from './AuthBottomLogin';

// Нижняя части формы/модалки
const AuthBottom: FC<IAuthTypeForm> = ({ type = 'email' }) => {
  return (
    <Box className={styles.bottom}>
      <div className={styles.wrapper}>
        <AuthBottomLogin type={type} />
      </div>
    </Box>
  );
};

export default AuthBottom;
